const colors = {
  toast: {
    normal: "#032A3E",
    danger: "#A84A4A",
    success: "#032A3E",
    warning: "#032A3E",
    icon: "#FFFFFF",
    text: "#FFFFFF",
  },
  statusBadge: {
    default: {
      background: {
        400: "#27272A",
        500: "#000000",
      },
      text: {
        400: "#71717A",
        500: "#FFFFFF",
      },
      border: {
        400: "#1C1C1E",
        500: "#3F3F46",
      },
    },
    warning: {
      50: "#FEF7EE",
      100: "#FCEDD8",
      200: "#F7D8B1",
      300: "#F2BB7F",
      400: "#EC954B",
      500: "#E77828",
      600: "#D8601E",
    },
    success: {
      50: "#F3FAF5",
      100: "#E3F5E9",
      200: "#C8EAD4",
      300: "#9DD8B3",
      400: "#6ABE8A",
      500: "#45A268",
      600: "#348352",
    },
    error: {
      50: "#FEF0F0",
      100: "#FDE2E2",
      200: "#FCD4D4",
      300: "#FAA9A9",
      400: "#F98D8D",
      500: "#F87171",
      600: "#DF6565",
    },
  },
  notes: {
    background: "#1C1C1E",
    indicator: "#535252",
    backgroundItem: "#3E3E40",
  },
};

export default colors;
